import React from 'react';
import { useTranslations } from 'next-intl';

import { CourseCard, CourseSkeleton, ICourse } from 'modules/courses';
import { isEmptyArr } from 'modules/global';

import { EmptyData, Visible } from 'components';

interface IProps {
  courses?: ICourse[];
  isLoading?: boolean;
}

const Courses: React.FC<IProps> = ({ courses, isLoading }) => {
  const t = useTranslations();

  return (
    <Visible
      if={isLoading}
      else={
        <Visible
          if={isEmptyArr(courses)}
          else={
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3">
              {courses?.map(course => <CourseCard key={course?.id} course={course} />)}
            </div>
          }
        >
          <EmptyData title={t('malumot_topilmadi')} />
        </Visible>
      }
    >
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3">
        {Array.from({ length: 8 }).map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <CourseSkeleton key={index} />
        ))}
      </div>
    </Visible>
  );
};

export default Courses;
